







import aboutMain from "../Assets/E10AJCMV.avif";
import aboutSecond from "../Assets/pexels-genihoka-39403185.jpg";
import aboutThird from "../Assets/nakhla.jpg";
import heroVideo1 from "../Assets/bluewaters-web.mp4";
import heroVideo2 from "../Assets/palm-web.mp4";
import heroVideo3 from "../Assets/v3-web.mp4";

// صور المشاريع (بدّلها بصورك)
// import p1 from "../Assets/marina.jpg";

const u = (id, w) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

// الهيرو بيعرض 3 فيديوهات جنب بعض بالترتيب ده (يمين/وسط/شمال حسب اتجاه اللغة)
// لو فيه أقل من 3، اللوح الناقص بيعيد فيديو من نقطة تانية
   export const HERO_VIDEOS = [heroVideo2, heroVideo1, heroVideo3];
// بتظهر لحد ما الفيديو يحمّل، وبديل لو فشل (لوح لكل صورة بالترتيب)
export const HERO_IMGS = [
  u("photo-1512453979798-5ea266f8880c", 2400),
  u("photo-1518684079-3c830dcef090", 2400),
];

export const ABOUT_IMGS = {
  main: [aboutMain],
  second: [aboutSecond],
  third: [aboutThird],
};

// نفس ترتيب المشاريع في الترجمة
export const PROJECT_IMGS = [
  [u("photo-1512453979798-5ea266f8880c", 1200)],
  [u("photo-1518684079-3c830dcef090", 1200)],
  [u("photo-1582672060674-bc2bd808a8b5", 1200)],
  [u("photo-1512632578888-169bbbc64f33", 1200)],
  [u("photo-1613490493576-7fde63acd811", 1200)],
];

export const BLOG_IMGS = [
  [u("photo-1560518883-ce09059eeffa", 1200), u("photo-1600585154340-be6161a56a0c", 1200)],
  [u("photo-1600607687939-ce8a6c25118c", 1200), u("photo-1600596542815-ffad4c1539a9", 1200)],
  [u("photo-1512453979798-5ea266f8880c", 1200)],
  [u("photo-1564013799919-ab600027ffc6", 1200), u("photo-1512917774080-9991f1c4c750", 1200)],
];